module.exports = __webpack_public_path__ + "img/ai_bg_blur.751f37b.png";